<template>
  <v-card outlined>
    <v-card-text>
      <!-- <v-layout row wrap align-center>
        <v-flex shrink v-if="InvoiceDetails.length > 0">
          <v-btn-toggle v-model="showCost" color="primary" dense group>
            <v-btn :value="1" text class="ma-0" outlined>
              <v-icon>mdi-currency-usd</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex shrink>
          <ReturnPhone @submit="insertReturn" />
        </v-flex>
        <v-flex>
          <v-chip
            v-if="totalQty !== 0"
            class="ma-2"
            color="indigo lighten-1"
            text-color="white"
          >
            <v-avatar left color="indigo " class="mr-2">
              <v-icon small color="white">mdi-cart-outline</v-icon>
            </v-avatar>
            <span class="title">{{ totalQty }}</span>
          </v-chip>
          <v-tooltip bottom v-if="replaceQty !== 0">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                color="yellow lighten-2"
                text-color="black"
              >
                <v-avatar left color="yellow" class="mr-2">
                  <v-icon small color="black">mdi-barcode-scan</v-icon>
                </v-avatar>
                <span class="title">{{ replaceQty }}</span>
              </v-chip>
            </template>
            <span>Serial Item need tobe replace</span>
          </v-tooltip>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-layout> -->

      <v-data-table
        id="invoice-cart"
        :search="search"
        :headers="headers"
        hide-default-footer
        :itemsPerPage="1000"
        no-data-text="No item on this invoice yet"
        :items="InvoiceDetails"
      >
        <template v-slot:item="{ item, index }">
          <tr :style="{ 'background-color': activeColor(item) }">
            <td>
              <v-layout align-center justify-start row fill-height wrap>
                <v-btn icon @click="deleteItem(index)" v-if="!item.delete">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <v-btn icon @click="unDeleteItem(index)" v-else>
                  <v-icon color="green">mdi-delete-empty</v-icon>
                </v-btn>
                <v-text-field
                  v-if="!item.delete"
                  v-model="item.name"
                  outlined
                  hide-details
                  @focus="$event.target.select()"
                  dense
                ></v-text-field>
                <span v-else :class="{ deleted: item.delete }">{{
                  item.name
                }}</span>
              </v-layout>
            </td>
            
            <td class="text-center">
              <v-text-field
                v-if="!item.delete"
                v-model="item.qty"
                :disabled="item.imeiNumber ? true : false"
                outlined
                type="number"
                class="centered-input"
                hide-details
                dense
                @focus="$event.target.select()"
              ></v-text-field>
              <span v-else :class="{ deleted: item.delete }">{{
                item.qty
              }}</span>
            </td>
            <td class="text-right">
              <v-text-field
                v-if="!item.delete"
                v-model="item.price"
                outlined
                :min="0"
                prepend-inner-icon="mdi-clipboard-check-outline"
                class="al-r"
                type="number"
                @click:prepend-inner="copyPrice(item, index)"
                hide-details
                @blur="checkPrice(item)"
                @focus="$event.target.select()"
                dense
              ></v-text-field>
              <span v-else :class="{ deleted: item.delete }">{{
                item.price | currency
              }}</span>
            </td>
            <td class="text-right">
              <span
                :class="{ deleted: item.delete }"
                :style="{
                  color:
                    parseFloat(item.price) > parseFloat(item.cost)
                      ? 'green'
                      : 'red',
                }"
                >{{ (item.qty * item.price) | currency }}</span
              >
              <span v-if="showCost">
                <span v-if="checkRightStatus(42)">
                  <v-text-field
                    v-if="showCost"
                    v-model="item.cost"
                    outlined
                    class="al-r"
                    hide-details
                    @focus="$event.target.select()"
                    dense
                  ></v-text-field>
                </span>

                <span v-else>/{{ item.cost | currency }}</span>
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
// const ReturnPhone = () => import("./ReturnPhone");

import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      openDialog: false,
      selectedItem: null,
      htmlHeight: 0,
      showCost: false,
      search: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Quantity",
          align: "center",
          value: "qty",
          width: "100",
          sortable: false,
        },
        {
          text: "Price",
          align: "right",
          value: "price",
          sortable: false,
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("invoice", [
      "InvoiceDetails",
      "totalQty",
      "getSelectedCustomer",
    ]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    replaceQty() {
      let value = 0;
      this.InvoiceDetails.map((row) => {
        if (row.needIMEINumber && !row.delete) value += row.qty;
      });

      return value;
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedDonor(val);
      },
    },
  },
  // components: {
  //   ReturnPhone,
  // },
  watch: {
    selectedCustomer() {
      this.changeHeight();
    },
  },
  mounted() {
    this.htmlHeight = document.documentElement.offsetHeight;
    this.changeHeight();
  },
  methods: {
    ...mapActions("invoice", [
      "AddInvoiceDetail",
      "SetSelectedDonor",
      "DeleteInvoiceDetailRow",
      "UnDeleteInvoiceDetailRow",
      "CopyPriceToAll",
    ]),
    openIMEICollect(item) {
      console.log("click here");
      this.openDialog = true;
      this.selectedItem = item;
    },
    activeColor(item) {
      let result = "transparent";
      if (item.receivedAt) result = "#FFFDE7";
      return result;
    },
    changeHeight() {
      let html = this.htmlHeight;
      let alert = document.getElementById("alert-col");

      if (alert) {
        alert = alert.offsetHeight;
      } else {
        alert = 0;
      }
      let newHeight = html - (580 + alert) + "px";
      document.getElementById("invoice-cart").style.height = newHeight;
    },
    copyPrice(item, index) {
      this.$swal({
        title: "Change Price To All",
        text: `You want to change all ${
          item.name
        } price to ${this.$options.filters.currency(item.price)}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.CopyPriceToAll(index);
        }
      });
    },
    async unDeleteItem(i) {
      await this.UnDeleteInvoiceDetailRow(i);
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "success",
          title: "Item was restore",
        });
    },
    async deleteItem(i) {
      await this.DeleteInvoiceDetailRow(i);
      this.$swal
      .mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      })
      .fire({
        icon: "success",
        title: "Item deleted",
      });
    },
    checkPrice(item) {
      if (parseFloat(item.price) < item.cost) {
        this.$swal({
          title: "Selling Blow Cost Price",
          text: `${item.name} cost price is ${this.$options.filters.currency(
            item.cost
          )}. You are selling it for ${this.$options.filters.currency(
            item.price
          )}below cost price. Are you sure?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (!result.value) {
            item.price = item.previousPrice;
            item.total = parseFloat(item.price) * parseFloat(item.qty);
          }
        });
      } else {
        item.total = parseFloat(item.price) * parseFloat(item.qty);
      }
    },
    insertReturn(val) {
      console.log("insert return", val);
      const imeiResult = this.InvoiceDetails.find(
        ({ imeiNumber }) => imeiNumber === val.imeiNumber
      );

      if (imeiResult) {
        this.$swal({
          title: "Return Item",
          text: "This item is already in list",
          icon: "error",
        });
        // this.$swal
        //   .mixin({
        //     toast: true,
        //     position: "top-right",
        //     showConfirmButton: true,
        //     timer: 3000,
        //   })
        //   .fire({
        //     icon: "error",
        //     title: `${val.imeiNumber} is already in this list`,
        //   });
      } else {
        this.AddInvoiceDetail({
          ProductId: val.ProductId,
          name: val.name,
          price: Math.abs(val.returnPrice),
          qty: -1,
          total: val.price * -1,
          cost: val.cost,
          imeiNumber: val.imeiNumber,
          lock: true,
        });
      }
    },
  },
};
</script>

<style scoped>
#invoice-cart {
  overflow: auto;
}
</style>
